module.exports = __webpack_public_path__ + "assets/1e4581afdf05b0ff45e14bb9e4536c12.png";